let urls =  {
  production: {
    sso: "https://sso.forgedrift.com",
    paymentsURL: "http://153.156.163.115:7003",
    inventoryURL: "http://153.156.163.115:7005",
    bucketUrl: "https://pub-uploads.s3.amazonaws.com/",
    objectKey: "uploads/",
    tenantType:"all"
  },
  development: {
    sso: "https://sso.forgedrift.com",
    paymentsURL: "http://153.156.163.115:7003",
    inventoryURL: "http://localhost:3006/",
    bucketUrl: "https://pub-uploads.s3.amazonaws.com/",
    objectKey: "uploads/",
    tenantType:"all"
  }
}

export function getUrls() {
  if(process.env.NODE_ENV == 'production') {
    return urls.production
  } else {
    return urls.development
  }
}

